import { render, staticRenderFns } from "./level_manage.vue?vue&type=template&id=88c5c064"
import script from "./level_manage.vue?vue&type=script&lang=js"
export * from "./level_manage.vue?vue&type=script&lang=js"
import style0 from "./level_manage.vue?vue&type=style&index=0&id=88c5c064&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports